import AppConstants from '../config/app.constants';

let ContractService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/contract`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data, branchId) => {
        return $http
            .post(AppConstants.api + `/contract/create`, {
                data,
                branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let remove = (id, branchId) => {
        return $http
            .delete(AppConstants.api + `/contract/${id}`, {
                params: {
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data, branchId) => {
        return $http
            .post(AppConstants.api + `/contract/${id}`, {
                data,
                branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/contract/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let getCustomerHistory = (searchText, contractId, sortASC, sortColumn, offset, limit,) => {
        return $http
            .get(AppConstants.api + `/contract/${contractId}/get-customer-history`, {
                params: {
                    searchText,
                    contractId,
                    sortASC,
                    sortColumn,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getCustomerList = (searchText, offset, limit) => {
        return $http
            .get(AppConstants.api + `/contract/get-customer-list`, {
                params: { searchText, offset, limit }
            })
            .then((res) => {
                return res.data
            })
    }
    
    let contractLocationList = (searchText, locationDistanceId, offset, limit) => {
        return $http
            .get(AppConstants.api + `/contract/get-contract-location-list`, {
                params: { searchText, locationDistanceId,offset, limit }
            })
            .then((res) => {
                return res.data
            })
    }

    let getCustomerLocationList = (contractId, locationDistanceId, searchText, offset, limit) => {
        return $http
            .get(AppConstants.api + `/contract/get-customer-location-list`, {
                params: { contractId, locationDistanceId, searchText, offset, limit }
            })
            .then((res) => {
                return res.data
            })
    }

    let assertLocationIds = (locationIds, contractId, useCustomerOnBillingRules, locationDistanceId) => {
        return $http
            .post(AppConstants.api + `/contract/assert-location-ids`, { locationIds, contractId, useCustomerOnBillingRules, locationDistanceId })
            .then((res) => {
                return res.data
            })
    }

    let updateContractRule = (id, data, branchId) => {
        return $http.post(AppConstants.api + `/contract/${id}/update-contract-rule`, {
            data,
            branchId
        }).then((res) => {
            return res.data
        })
    }

    let deleteContractRule = (id, data, branchId) => {
        let payload = {
            data,
            branchId
        }

        return $http.post(AppConstants.api + `/contract/${id}/delete-contract-rule`, payload).then((res) => {
            return res.data
        })
    }

    let getContractLogs = (contractId, search, offset, limit) => {
        return $http.get(AppConstants.api + `/contract/${contractId}/logs`, {
            params: {
                search,
                offset,
                limit
            }
        }).then((res) => {
            return res.data
        })
    }

    let exportDataToCSV = (contractId, search) => {
        return $http.get(AppConstants.api + `/contract/${contractId}/export-to-csv`, {
            params: {
                search
            }
        }).then((res) => {
            return res.data
        })
    }


    let getContractRulesLocation = (contractId, searchText) => {
        return $http
            .get(AppConstants.api + `/contract/get-contract-rules-location`, {
                params: { contractId, searchText }
            })
            .then((res) => {
                return res.data
            })
    };

    let getUncoveredOnCallLocations = (offset, limit, isCount = false) => {
        return $http
            .get(AppConstants.api + `/contract/uncovered-on-call-locations`, {
                params: { isCount, offset, limit }
            })
            .then((res) => {
                return res.data
            })
    };

    return {
        all,
        create,
        remove,
        update,
        get,
        getCustomerHistory,
        contractLocationList,
        getCustomerList,
        getCustomerLocationList,
        assertLocationIds,
        updateContractRule,
        deleteContractRule,
        getContractLogs,
        exportDataToCSV,
        getContractRulesLocation,
        getUncoveredOnCallLocations
    };
};

ContractService.$inject = ['$http', '$q']

export default ContractService;


// WEBPACK FOOTER //
// ./client/app/services/contract.service.js